// ctaConfig.js
import React from 'react';
import CTAButtonMob from '../Components/CTA/CTAButtonMob.jsx';
import { Rocket } from 'lucide-react';

const ctaConfig = {
  om1: {
    button: "View Free Trial",
    link: "https://www.oddsmonkey.com/affiliates/affiliate.php?id=66317",
    content: (
      <div>
        <CTAButtonMob
            to="https://www.oddsmonkey.com/affiliates/affiliate.php?id=66317"
            external='true'
            text="See OddsMonkey for yourself"
            buttonText="Visit"
            icon={Rocket}
            tabText="Free trial available"
        />
        <p>Learn how OddsMonkey pays for itself many times over.</p> 
        <p>We think OddsMonkey provide the best tools for matched bettors, and we're proud to recommend them.</p>
      </div>
    )
  },
  om2: {
    button: "View Free Trial",
    link: "https://www.oddsmonkey.com/affiliates/affiliate.php?id=66317",
    content: (
      <div>
        <CTAButtonMob
            to="https://www.oddsmonkey.com/affiliates/affiliate.php?id=66317"
            external='true'
            text="OddsMonkey: Get the Ultimate Matched Betting Tool"
            buttonText="Learn How to Profit"
            icon={Rocket}
            tabText="Free trial available"
        />
        <p>OddsMonkey guides you through bookie offers, helps you find the best matched bets and lets you place your bets with a click.</p> 
        <p>We think OddsMonkey provide the best tools for matched bettors, and we're proud to recommend them.</p>
      </div>
    )
  },
  om3: {
    button: "View Free Trial",
    link: "https://www.oddsmonkey.com/affiliates/affiliate.php?id=66317",
    content: (
      <div>
        <CTAButtonMob
            to="https://www.oddsmonkey.com/affiliates/affiliate.php?id=66317"
            external='true'
            text="OddsMonkey: Get the Ultimate Matched Betting Tools"
            buttonText="Learn How to Profit"
            icon={Rocket}
            tabText="Free trial available"
        />
        <p>Want to find acca combinations to match bookie offers automatically, and sequentially lay your accas to maximise profit? You need OddsMonkey.</p>
        <p>We think OddsMonkey provide the best tools for matched bettors, and we're proud to recommend them.</p>
      </div>
    )
  },
  om4: {
    button: "View Free Trial",
    link: "https://www.oddsmonkey.com/affiliates/affiliate.php?id=66317",
    content: (
      <div>
        <CTAButtonMob
            to="https://www.oddsmonkey.com/affiliates/affiliate.php?id=66317"
            external='true'
            text="OddsMonkey: Get the Ultimate Matched Betting Tools"
            buttonText="Learn How to Profit"
            icon={Rocket}
            tabText="Free trial available"
        />
        <p>Want to find the best bet builder lay options to match bookie offers? You need OddsMonkey.</p>
        <p>We think OddsMonkey provide the best tools for matched bettors, and we're proud to recommend them.</p>
      </div>
    )
  }
};

export default ctaConfig;
